import { useState } from "react";

import { UserRead } from "@nens/rana/api-v1";

// There are two different modals on the user list page:
// 1. Deactivate user
// 2. Invite user
// Only one user can be deactivated at a time. Keep track of it here.
// If the invite modal is open, there is no modal user.

type OpenModal =
  | {
      modal: "change-role";
      currentModalUser: UserRead;
    }
  | {
      modal: "deactivate" | "activate";
      currentModalUsers: UserRead[];
    }
  | {
      modal: "invite";
    }
  | null;

export function useTenantUserModal() {
  const [modal, setModal] = useState<OpenModal>(null);

  return {
    modal,
    openChangeRoleModal: (user: UserRead) => {
      setModal({ modal: "change-role", currentModalUser: user });
    },
    openDeactivateModal: (users: UserRead[]) => {
      setModal({ modal: "deactivate", currentModalUsers: users });
    },
    openActivateModal: (users: UserRead[]) => {
      setModal({ modal: "activate", currentModalUsers: users });
    },
    openInviteModal: () => {
      setModal({ modal: "invite" });
    },
    closeModal: () => {
      setModal(null);
    },
  };
}
